module.exports = __webpack_public_path__ + "img/museum.3268d7bf.png";